
import { mapState } from 'vuex';
import Gallery from './components/Gallery.vue';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsGallery.WidgetCategoryReviewsGalleryMobile',
  name: 'WidgetCategoryReviewsGalleryMobile',
  components: { Gallery },
  computed: {
    ...mapState('widget', ['widget']),
    galleryProps() {
      return { rowGap: 32, ...this.reviewLayoutProps };
    },
    reviewLayoutProps() {
      switch (this.widget.posts_per_line) {
        case 2:
          return { cols: 2, gutter: 16, productImageSize: 32 };
        case 3:
          return { cols: 3, gutter: 14, productImageSize: 32 };
        default:
          return { cols: 1, gutter: 0, productImageSize: 40 };
      }
    }
  }
};
